import { render, staticRenderFns } from "./IconsBaseLink.vue?vue&type=template&id=057755c0&scoped=true&"
import script from "./IconsBaseLink.vue?vue&type=script&lang=js&"
export * from "./IconsBaseLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057755c0",
  null
  
)

export default component.exports